module.exports = __webpack_public_path__ + "img/restaurant.88f91c2f.svg";